import React from 'react';

const formatDate = (date) => {
  return new Intl.DateTimeFormat('zh-TW', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(`${date}T00:00:00`));
};

const ContentDates = ({published, updated, className = ''}) => {
  const publishedLabel = formatDate(published);
  const updatedLabel = formatDate(updated);

  return (
    <p
      className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs sm:text-sm text-gray-500 ${className}`}
      aria-label={`首次發布：${publishedLabel}，最後更新：${updatedLabel}`}
      data-content-dates
    >
      <span>
        首次發布：
        <time dateTime={published} itemProp="datePublished">
          {publishedLabel}
        </time>
      </span>
      <span aria-hidden="true">•</span>
      <span>
        最後更新：
        <time dateTime={updated} itemProp="dateModified">
          {updatedLabel}
        </time>
      </span>
    </p>
  );
};

export default ContentDates;